import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import styles from './LeaveAgencyDialog.scss';
import { setPopUp } from 'actions/environment';
import cn from 'classnames';
import { leaveProfileAgency } from '../../../actions/profile';
import { userLogout } from 'actions/loginForms';
import { gaEvent, trackGA } from '../../../services/ga';
import { withRouter } from 'react-router-dom';

class LeaveAgencyDialog extends Component {
  handleLeaveAgencyClick = async () => {
    const { profile, location } = this.props;
    const eventName =
    location.pathname === '/'
      ? 'agencyNoAccessDialogButtonsClick'
      : 'leaveAgencyDialogButtonsClick';

    if (profile) {
      trackGA(
        gaEvent[eventName]({
          screenName: location.pathname,
          eventLabel: 'vyiti_agenstvo_uveren',
          user_id: profile.id,
        })
      );
    }

    try {
      const { leaveProfileAgency, userLogout, setPopUp } = this.props;
      const result = await leaveProfileAgency();
      if (result.response.data.status) {
        await userLogout();
      } else {
        setPopUp();
      }
    } catch (error) {
      this.handleClosePopup();
      console.error(error);
    }
  };

  handleClosePopup = () => {
    const { profile, location } = this.props;
    const eventName =
      location.pathname === '/'
        ? 'agencyNoAccessDialogButtonsClick'
        : 'leaveAgencyDialogButtonsClick';

    trackGA(
      gaEvent[eventName]({
        screenName: location.pathname,
        eventLabel: 'vyiti_agenstvo_otmena',
        user_id: profile.id,
      })
    );

    this.props.setPopUp();
  };

  render() {
    const { t } = this.props;

    return (
      <div>
        <div className={styles.PopupContent}>
          <div>
            <div className={styles.PopupTitle}>
              {t('components.profile.profileForm.leaveAgencyDialog.title')}
            </div>
            <div className={styles.Divider} />
            <div className={styles.PopupSubtitle}>
              {t('components.profile.profileForm.leaveAgencyDialog.subtitle')}
            </div>
            <button
              className={cn(
                styles.ActionBtn,
                styles.LeaveAgencyButton,
                'button-primary',
                'button-primary--md'
              )}
              onClick={this.handleLeaveAgencyClick}
            >
              {t('components.profile.profileForm.leaveAgencyDialog.leave')}
            </button>
            <button
              className={cn(
                styles.ActionBtn,
                styles.LeaveAgencyButton,
                'button-default',
                'button-primary--md'
              )}
              onClick={this.handleClosePopup}
            >
              {t('components.profile.profileForm.leaveAgencyDialog.cancel')}
            </button>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  profile: state.profile,
});

export default withRouter(
  withTranslation()(
    connect(mapStateToProps, {
      setPopUp,
      leaveProfileAgency,
      userLogout,
    })(LeaveAgencyDialog)
  )
);



// WEBPACK FOOTER //
// ./src/components/Profile/LeaveAgency/LeaveAgencyDialog.js